import { isHighlightSpanElement } from '@standardnotes/ui-services/src/Import/HighlightSpanImport';
import { $isTextNode } from 'lexical';
function applyHighlightToTextChild(domNode) {
    const backgroundColor = domNode.style.backgroundColor;
    return {
        forChild: (lexicalNode) => {
            if (!$isTextNode(lexicalNode)) {
                return lexicalNode;
            }
            if (!lexicalNode.hasFormat('highlight')) {
                lexicalNode.toggleFormat('highlight');
            }
            if (backgroundColor) {
                lexicalNode.setStyle(`background-color: ${backgroundColor}`);
            }
            return lexicalNode;
        },
        node: null,
    };
}
export const highlightHtmlImport = {
    mark: () => ({
        conversion: applyHighlightToTextChild,
        priority: 1,
    }),
    span: (domNode) => {
        if (!isHighlightSpanElement(domNode)) {
            return null;
        }
        return {
            conversion: applyHighlightToTextChild,
            priority: 1,
        };
    },
};
